/* eslint-disable no-unused-vars */
import {
  Box,
  Breadcrumbs,
  Container,
  Grid,
  Link,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { Helmet } from "react-helmet-async";
import { Link as RouterLink } from "react-router-dom";
import PredictedTrendsForOffer from "../../components/dashboard/charts/PredictedTrendsForOffer";
import ChevronRightIcon from "../../icons/ChevronRight";
import { hasPermission } from "../../utils/handlePermissions";
import OfferAutocomplete from "../../components/dashboard/OfferAutocomplete";
import { format, formatISO, subDays } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import DateRangePickerCustom from "../../components/dashboard/DateRangePicker";
import { graphQLApiService } from "src/services/GraphQLApiService";
import {
  GET_TRIP_ANALYTICS,
  GET_TRIP_ANALYTICS_META,
  GET_TYPE_ENUMS,
} from "src/queries/prediction/tripAnalyticsQuery";
import { GET_REGIONS_AND_CITIES } from "src/queries/prediction/destinationQuery";
import { GET_STATS_BY_OFFER } from "src/queries/prediction/offerQuery";
import { useTranslation } from "react-i18next";

const OfferByCountry = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [mealTypes, setMealTypes] = useState([]);
  const [offerTypes, setOfferTypes] = useState([]);
  const [transportTypes, setTransportTypes] = useState([]);
  const [dates, setDates] = useState([]);
  const [cities, setCities] = useState([]);

  const [stats, setStats] = useState({ min: [], max: [], avg: [] });
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState({ value: "GR" });
  const [selectedOfferType, setSelectedOfferType] = useState("STAY");
  const [selectedTransport, setSelectedTransport] = useState("FLIGHT");
  const [selectedDepartureCity, setSelectedDepartureCity] = useState("Gdansk");
  const [selectedPeriodLength, setSelectedPeriodLength] = useState(7);
  const [selectedMealCode, setSelectedMealCode] = useState("AI");

  const [departureCityNames, setDepartureCityNames] = useState([]);
  const [departureAirportCodeNames, setDepartureAirportCodeNames] = useState(
    []
  );
  const [departureStats, setDepartureStats] = useState({
    min: [],
    max: [],
    avg: [],
  });

  const [mealNames, setMealNames] = useState([]);
  const [mealStats, setMealStats] = useState({
    min: [],
    max: [],
    avg: [],
  });
  const [propertyCategoryNames, setPropertyCategoryNames] = useState([]);
  const [propertyCategoryStats, setPropertyCategoryStats] = useState({
    min: [],
    max: [],
    avg: [],
  });
  const [transportTypeNames, setTransportTypeNames] = useState([]);
  const [transportTypeStats, setTransportTypeStats] = useState({
    min: [],
    max: [],
    avg: [],
  });
  const [tripDurationNames, setTripDurationNames] = useState([]);
  const [tripDurationStats, setTripDurationStats] = useState({
    min: [],
    max: [],
    avg: [],
  });

  const [selectionRange, setState] = useState([
    {
      startDate: subDays(new Date("2023-07-31"), 30),
      endDate: new Date("2023-07-31"),
      key: "selection",
    },
  ]);

  useEffect(() => {
    graphQLApiService
      .query(GET_TRIP_ANALYTICS_META, {
        startDate: formatISO(selectionRange[0].startDate).split("T")[0],
        endDate: formatISO(selectionRange[0].endDate).split("T")[0],
      })
      .then((result: any) => {
        const countries = result?.data?.tripAnalytics?.countries?.nodes || [];
        setCountries(
          countries.map((item) => ({
            value: item.countryCode,
            label: item.name,
          }))
        );
      });

    graphQLApiService
      .query(GET_TRIP_ANALYTICS, {
        startDate: format(selectionRange[0].startDate, "yyyy-MM-dd"),
        endDate: format(selectionRange[0].endDate, "yyyy-MM-dd"),
      })
      .then((data) => {
        let stats = { min: [], max: [], avg: [] };
        let names = [];
        let airportCodes = [];

        stats = { min: [], max: [], avg: [] };
        names = [];
        data.data.tripAnalytics.statsByDepartureFrom.forEach((item) => {
          names.push(item.departureCity);
          airportCodes.push(item.departureAirportCode);
          stats.min.push(item.minimumBasePrice);
          stats.max.push(item.maximumBasePrice);
          stats.avg.push(item.averageBasePrice);
        });
        setDepartureStats(stats);
        setDepartureCityNames(names);
        setDepartureAirportCodeNames(airportCodes);

        stats = { min: [], max: [], avg: [] };
        names = [];
        data.data.tripAnalytics.statsByMeal.forEach((item) => {
          names.push(item.mealCode);
          stats.min.push(item.minimumBasePrice);
          stats.max.push(item.maximumBasePrice);
          stats.avg.push(item.averageBasePrice);
        });
        setMealStats(stats);
        setMealNames(names);

        stats = { min: [], max: [], avg: [] };
        names = [];
        data.data.tripAnalytics.statsByPropertyCategory.forEach((item) => {
          names.push(item.propertyCategory);
          stats.min.push(item.minimumBasePrice);
          stats.max.push(item.maximumBasePrice);
          stats.avg.push(item.averageBasePrice);
        });
        setPropertyCategoryStats(stats);
        setPropertyCategoryNames(names);

        stats = { min: [], max: [], avg: [] };
        names = [];
        data.data.tripAnalytics.statsByTransportType.forEach((item) => {
          names.push(item.transportType);
          stats.min.push(item.minimumBasePrice);
          stats.max.push(item.maximumBasePrice);
          stats.avg.push(item.averageBasePrice);
        });
        setTransportTypeStats(stats);
        setTransportTypeNames(names);

        stats = { min: [], max: [], avg: [] };
        names = [];
        data.data.tripAnalytics.statsByTripDuration.forEach((item) => {
          names.push(item.tripDuration);
          stats.min.push(item.minimumBasePrice);
          stats.max.push(item.maximumBasePrice);
          stats.avg.push(item.averageBasePrice);
        });
        setTripDurationStats(stats);
        setTripDurationNames(names);
      });

    graphQLApiService.query(GET_TYPE_ENUMS, {}).then((result: any) => {
      setMealTypes(
        (result?.data?.MealCode?.enumValues || []).map((item) => ({
          label: item.description,
          value: item.name,
        }))
      );
      setOfferTypes(
        (result?.data?.Offer?.enumValues || []).map((item) => ({
          label: item.description,
          value: item.name,
        }))
      );
      setTransportTypes(
        (result?.data?.Transport?.enumValues || []).map((item) => ({
          label: item.description,
          value: item.name,
        }))
      );
    });

    graphQLApiService
      .query(GET_REGIONS_AND_CITIES, {
        startDate: formatISO(selectionRange[0].startDate).split("T")[0],
        endDate: formatISO(selectionRange[0].endDate).split("T")[0],
        countryCode: selectedCountry.value,
      })
      .then((result: any) => {
        if (result.data) {
          let cities = [];
          result.data.tripAnalytics?.country?.region?.cities?.nodes.forEach(
            (item) => {
              cities.push(item.name);
            }
          );
          setCities(cities);
        } else {
          setCities([]);
        }
      });
  }, [selectionRange, selectedCountry]);

  useEffect(() => {
    graphQLApiService
      .query(GET_STATS_BY_OFFER, {
        startDate: formatISO(selectionRange[0].startDate).split("T")[0],
        endDate: formatISO(selectionRange[0].endDate).split("T")[0],
        countryCode: [selectedCountry.value],
        transportType: selectedTransport,
        offerType: selectedOfferType,
        departureCity: selectedDepartureCity,
        length: selectedPeriodLength || 7,
        mealCode: selectedMealCode,
        limit: 10000,
      })
      .then((result: any) => {
        const data = result?.data?.tripAnalytics?.statsByDate || null;
        if (data && data.length > 0) {
          let dates = [];
          let stat = { min: [], max: [], avg: [] };
          data.forEach((item) => {
            dates.push(item.date);
            stat.min.push(item.minimumBasePrice);
            stat.max.push(item.maximumBasePrice);
            stat.avg.push(item.averageBasePrice);
          });
          setDates(dates);
          setStats(stat);
        } else {
          setDates([]);
          setStats({ min: [], max: [], avg: [] });
        }
      });
  }, [
    selectionRange,
    selectedCountry,
    selectedTransport,
    selectedOfferType,
    selectedDepartureCity,
    selectedPeriodLength,
    selectedMealCode,
  ]);
  return (
    <>
      {hasPermission("dashboard_analytics_offer") && (
        <>
          <Helmet>
            <title>
              Dashboard: {t("title.Offer by country")} | Qtravel Search
            </title>
          </Helmet>
          <Box
            sx={{
              backgroundColor: "background.default",
              minHeight: "100%",
              py: 4,
            }}
          >
            <Container>
              <Grid
                container
                alignItems="end"
                justifyContent="space-between"
                spacing={3}
              >
                <Grid item>
                  <Typography color="textPrimary" variant="h5">
                    {t("title.Offer by country")}
                  </Typography>
                  <Breadcrumbs
                    aria-label="breadcrumb"
                    separator={<ChevronRightIcon fontSize="small" />}
                    sx={{ mt: 1 }}
                  >
                    <Link
                      color="textPrimary"
                      component={RouterLink}
                      to="/dashboard/main"
                      variant="subtitle2"
                    >
                      Dashboard
                    </Link>
                    <Typography color="textSecondary" variant="subtitle2">
                      {t("title.Offer by country")}
                    </Typography>
                  </Breadcrumbs>
                </Grid>
                <Grid item>
                  <DateRangePickerCustom
                    color={"primary"}
                    label={t(`other.analyze_msg`)}
                  />
                </Grid>
              </Grid>
              <Typography color="textSecondary" variant="h6" sx={{ py: 3 }}>
                {t("pages.prediction.select_msg_hotel")}
              </Typography>
              <Box sx={{ display: "flex" }}>
                <OfferAutocomplete />
              </Box>
              <Box sx={{ backgroundColor: "background.default", pt: 3 }}>
                <PredictedTrendsForOffer
                  categories={[
                    "25-05-2023",
                    "26-05-2023",
                    "27-05-2023",
                    "28-05-2023",
                    "29-05-2023",
                    "30-05-2023",
                    "31-05-2023",
                    "01-06-2023",
                  ]}
                  data={{
                    min: [
                      1700.4, 2700, 3400.5, 3400.5, 4400.5, 4800.8, 5100.8,
                      4000.6,
                    ],
                    max: [
                      2300.1, 3100, 3800.1, 3900, 4500.1, 5800.9, 5800.5,
                      6600.5,
                    ],
                    avg: [2000, 2900, 3700, 3600, 4400, 5200, 5500, 5800],
                  }}
                  title={t(`title.Offer`)}
                  tooltipInfo={t(`other.tooltip_offer_country`)}
                />
              </Box>
              <Box sx={{ backgroundColor: "background.default", pt: 3 }}>
                <PredictedTrendsForOffer
                  categories={[
                    "Week nr 21 22-28.05.2023",
                    "Week nr 22 29-04.06.2023",
                    "Week nr 23 05-11.06.2023",
                    "Week nr 24 12-18.06.2023",
                    "Week nr 25 19-25.06.2023",
                    "Week nr 26 26-02.07.2023",
                    "Week nr 27 03-09.07.2023",
                    "Week nr 28 10-16.07.2023",
                  ]}
                  data={{
                    min: [
                      1700.4, 2700, 3400.5, 3400.5, 4400.5, 4800.8, 5100.8,
                      4000.6,
                    ],
                    max: [
                      2300.1, 3100, 3800.1, 3900, 4500.1, 5800.9, 5800.5,
                      6600.5,
                    ],
                    avg: [2000, 2900, 3700, 3600, 4400, 5200, 5500, 5800],
                  }}
                  title={t(`other.departure_weeks`)}
                  tooltipInfo={t(`other.tooltip_Destination_country_1`)}
                />
              </Box>
              <Box sx={{ backgroundColor: "background.default", pt: 3 }}>
                <PredictedTrendsForOffer
                  categories={["May", "June", "July"]}
                  data={{
                    min: [800, 1500, 2200],
                    max: [1800, 1700, 2600],
                    avg: [1300, 1600, 2400],
                  }}
                  title={t(`other.departure_months`)}
                  tooltipInfo={t(`other.tooltip_Destination_price`)}
                />
              </Box>
            </Container>
          </Box>
        </>
      )}
    </>
  );
};

export default OfferByCountry;
